export const TRANSLATIONS = {
  en: {
    // title: "AFR Digital Assistant",
    subtitle: "Digitally analyze your documents with smart automation",
    popUploadLabel: "PoP Upload",
    blLabel: "BL Number",
    blPlaceholder: "Enter BL Number",
    blRequired: "BL Number is required.",
    invoiceLabel: "Invoice Number",
    invoicePlaceholder: "Enter Invoice Number",
    invoiceRequired: "Invoice Number is required.",
    toolResultHeader: "Tool result",
    toolResultPlaceholder: "Tool result will appear here after processing.",
    confirmButton: "Confirm and Validate",
    editButton: "Edit",
    successTitle: "Successful",
    successText:
      "We have received your Proof of Payment and a Case ID has been created for your reference. Our team will verify the details and get back to you shortly.",
    goBack: "Go back",
    statusExtracting: "Extracting data from PoP...",
    confirmSuccess: "PoP confirmed successfully.",
    extractError: "Something went wrong while extracting. Please try again.",
    submitError: "Something went wrong while submitting. Please try again.",
    toastSubmitting: "Submitting PoP...",
    statusSubmitting: "File processing...",
    mismatchTitle: "Information mismatch detected",
    mismatchWarning:
      "The data will be checked against backend system please verify all details accurately to avoid any delay",
    mismatchText:
      "There has been a mismatch between the extracted data and the edited values. Are you sure you want to continue?",
    mismatchContinueButton: "Continue",
    mismatchEditButton: "Edit again",
    mismatchCommentPlaceholder: "Add any comments or notes (optional)",
    mismatchEmailLabel: "Email Address",
    mismatchEmailPlaceholder: "Enter your email",
    mismatchSummaryLabel: "Changes Summary",
    mismatchFileLabel: "File",
    blOrInvoiceRequired: "At least one of BL Number or Invoice Number is required.",
    blInputInfo:
      "Enter multiple BL numbers separated by commas (e.g., BL001,BL002,BL003)",
    invoiceInputInfo:
      "Enter multiple invoice numbers separated by commas (e.g., INV001,INV002,INV003)",
    invalidCharacters:
      "Only commas are allowed as separators. Remove spaces and special characters.",
    countryLabel: "Country",
    countryPlaceholder: "Select country",
    popCounter: "PoP {current} of {total}",
    nextButton: "Next",
    previousButton: "Previous",
    editFileTitle: "Select file to edit",
    cancelButton: "Cancel",
    submitAllButton: "Submit All",
    chooseFiles: "Choose files",
    filesSelected: "{count} file(s) selected",
    submissionSummaryTitle: "Submission summary",
    noEditsMessage: "No edits were made. Data submitted as extracted.",
    originalLabel: "Original",
    changedToLabel: "Changed to",
    howToUseTitle: "This is how you use the tool",
    languageLabel: "Language",
  },
  es: {
    title: "Asistente Digital AFR",
    subtitle: "Analice digitalmente sus documentos con automatización inteligente",
    popUploadLabel: "Cargar PoP",
    blLabel: "Número BL",
    blPlaceholder: "Introduzca el número BL",
    blRequired: "El número BL es obligatorio.",
    invoiceLabel: "Número de factura",
    invoicePlaceholder: "Introduzca el número de factura",
    invoiceRequired: "El número de factura es obligatorio.",
    toolResultHeader: "Resultado de la herramienta",
    toolResultPlaceholder:
      "El resultado de la herramienta aparecerá aquí después del procesamiento.",
    confirmButton: "Confirmar",
    editButton: "Editar",
    successTitle: "Correcto",
    successText:
      "Hemos recibido su comprobante de pago. Nuestro equipo verificará los datos y se pondrá en contacto con usted en breve.",
    goBack: "Volver",
    statusExtracting: "Extrayendo datos del PoP...",
    confirmSuccess: "PoP confirmado correctamente.",
    extractError: "Se produjo un error al extraer los datos. Inténtelo de nuevo.",
    submitError: "Se produjo un error al enviar los datos. Inténtelo de nuevo.",
    toastSubmitting: "Enviando PoP...",
    statusSubmitting: "Procesando archivo...",
    mismatchTitle: "Se detectó una discrepancia de datos",
    mismatchWarning:
      "Los datos se verificarán en el sistema backend, verifique todos los detalles con precisión para evitar retrasos",
    mismatchText:
      "Hay una diferencia entre los datos extraídos y los valores editados. ¿Seguro que desea continuar?",
    mismatchContinueButton: "Continuar",
    mismatchEditButton: "Editar de nuevo",
    mismatchCommentPlaceholder: "Agregue comentarios o notas (opcional)",
    mismatchEmailLabel: "Correo Electrónico",
    mismatchEmailPlaceholder: "Ingrese su correo electrónico",
    mismatchSummaryLabel: "Resumen de Cambios",
    mismatchFileLabel: "Archivo",
    blOrInvoiceRequired:
      "Al menos uno de Número BL o Número de Factura es obligatorio.",
    blInputInfo:
      "Ingrese múltiples números BL separados por comas (ej: BL001,BL002,BL003)",
    invoiceInputInfo:
      "Ingrese múltiples números de factura separados por comas (ej: INV001,INV002,INV003)",
    invalidCharacters:
      "Solo se permiten comas como separadores. Elimine espacios y caracteres especiales.",
    countryLabel: "País",
    countryPlaceholder: "Seleccione país",
    popCounter: "PoP {current} de {total}",
    nextButton: "Siguiente",
    previousButton: "Anterior",
    editFileTitle: "Seleccione el archivo para editar",
    cancelButton: "Cancelar",
    submitAllButton: "Enviar Todo",
    chooseFiles: "Elegir archivos",
    filesSelected: "{count} archivo(s) seleccionado(s)",
    submissionSummaryTitle: "Resumen del envío",
    noEditsMessage: "No se realizaron ediciones. Datos enviados tal como se extrajeron.",
    originalLabel: "Original",
    changedToLabel: "Cambiado a",
    howToUseTitle: "Así es como se utiliza la herramienta",
    languageLabel: "Idioma",
  },
  fr: {
    title: "Assistant numérique AFR",
    subtitle:
      "Analysez numériquement vos documents avec l'automatisation intelligente",
    popUploadLabel: "Téléverser le PoP",
    blLabel: "Numéro de BL",
    blPlaceholder: "Saisir le numéro de BL",
    blRequired: "Le numéro de BL est requis.",
    invoiceLabel: "Numéro de facture",
    invoicePlaceholder: "Saisir le numéro de facture",
    invoiceRequired: "Le numéro de facture est requis.",
    toolResultHeader: "Résultat de l'outil",
    toolResultPlaceholder:
      "Le résultat de l'outil apparaîtra ici après le traitement.",
    confirmButton: "Confirmer",
    editButton: "Modifier",
    successTitle: "Réussi",
    successText:
      "Nous avons reçu votre preuve de paiement. Notre équipe vérifiera les informations et vous recontactera rapidement.",
    goBack: "Retour",
    statusExtracting: "Extraction des données du PoP...",
    confirmSuccess: "PoP confirmé avec succès.",
    extractError:
      "Une erreur s'est produite lors de l'extraction. Veuillez réessayer.",
    submitError:
      "Une erreur s'est produite lors de l'envoi. Veuillez réessayer.",
    toastSubmitting: "Envoi du PoP...",
    statusSubmitting: "Traitement du fichier...",
    mismatchTitle: "Incohérence d'informations détectée",
    mismatchWarning:
      "Les données seront vérifiées par rapport au système backend. Veuillez vérifier tous les détails avec précision pour éviter tout retard",
    mismatchText:
      "Il existe une différence entre les données extraites et les valeurs modifiées. Êtes-vous sûr de vouloir continuer ?",
    mismatchEmailLabel: "Adresse E-mail",
    mismatchEmailPlaceholder: "Entrez votre e-mail",
    mismatchSummaryLabel: "Résumé des Modifications",
    mismatchFileLabel: "Fichier",
    mismatchContinueButton: "Continuer",
    mismatchEditButton: "Modifier à nouveau",
    mismatchCommentPlaceholder:
      "Ajouter des commentaires ou des notes (facultatif)",
    blOrInvoiceRequired:
      "Au moins l'un des numéros BL ou numéro de facture est requis.",
    blInputInfo:
      "Entrez plusieurs numéros BL séparés par des virgules (ex: BL001,BL002,BL003)",
    invoiceInputInfo:
      "Entrez plusieurs numéros de facture séparés par des virgules (ex: INV001,INV002,INV003)",
    invalidCharacters:
      "Seules les virgules sont autorisées comme séparateurs. Supprimez les espaces et les caractères spéciaux.",
    countryLabel: "Pays",
    countryPlaceholder: "Sélectionner le pays",
    popCounter: "PoP {current} sur {total}",
    nextButton: "Suivant",
    previousButton: "Précédent",
    editFileTitle: "Sélectionnez le fichier à modifier",
    cancelButton: "Annuler",
    submitAllButton: "Tout Soumettre",
    chooseFiles: "Choisir des fichiers",
    filesSelected: "{count} fichier(s) sélectionné(s)",
    submissionSummaryTitle: "Résumé de la soumission",
    noEditsMessage: "Aucune modification. Données soumises telles qu'extraites.",
    originalLabel: "Original",
    changedToLabel: "Modifié en",
    howToUseTitle: "Voici comment utiliser l'outil",
    languageLabel: "Langue",
  },
};

export const COUNTRIES = [
  "Belgium",
  "Colombia",
  "Costa Rica",
  "Croatia",
  "Czech Republic",
  "Denmark",
  "Dominican Republic",
  "Ecuador",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Latvia",
  "Lithuania",
  "Malaysia",
  "Netherlands",
  "Norway",
  "Panama",
  "Paraguay",
  "Peru",
  "Poland",
  "Romania",
  "Slovakia",
  "Slovenia",
  "Sweden",
  "Switzerland",
  "Trinidad and Tobago",
  "Turkey",
  "Uruguay",
  "Venezuela",
];
